import { ReactComponent as NumberOne } from "../../images/svg/01.svg";
import { ReactComponent as NumberTwo } from "../../images/svg/02.svg";
import { ReactComponent as NumberThree } from "../../images/svg/03.svg";
import { ReactComponent as NumberFour } from "../../images/svg/04.svg";
import { ReactComponent as ClockIcon } from "../../images/svg/clock.svg";
import { ReactComponent as LayersIcon } from "../../images/svg/layers.svg";

import imgOne from "../../images/img_1.webp";
import imgTwo from "../../images/img_2.webp";
import imgThree from "../../images/img_3.webp";
import imgFour from "../../images/img_4.webp";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { scroller } from "react-scroll";
import React from "react";
import LazyOnView from "../LazyOnView"

import desktopBg from "../../images/bg_v2.webp";
import desktopBg2x from "../../images/bg_v2_2x.webp";
import mobileBg from "../../images/430px/bg_v2.webp";
import mobileBg2x from "../../images/430px/bg_v2_2x.webp";

const LazyAppointment = React.lazy(() => import("./LazyAppointment"));

const Main = () => {
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  useEffect(() => {
    if (location.hash === "#main") {
      const timer = setTimeout(() => {
        scroller.scrollTo("main", {
          smooth: true,
          duration: 500,
        });
      }, 200);
      
      // Очистка таймера для предотвращения утечек памяти
      return () => clearTimeout(timer);
    }
  }, [location.hash]);


  return (
    <section
      name="main"
      className="hero"
    >
      <picture>
        <source
          media="(max-width: 1024px)"
          srcSet={`${mobileBg} 1x, ${mobileBg2x} 2x`}
        />
        <img
          className="hero_bg_video"
          src={desktopBg}
          srcSet={`${desktopBg} 1x, ${desktopBg2x} 2x`}
          alt=""
          aria-hidden="true"
          fetchPriority="high"
        />
      </picture>
      <div className="hero_info_block">
        <div className="hero_top">
          <ClockIcon aria-label="Время" />

          <p className="hero_top_text">
            За <span className="hero_text_bold">60 минут</span> приёма Вы получите:
          </p>
        </div>
        <ul className="hero_middle">
          <li className="hero_middle_item">
            <img
              className="hero_middle_item_img"
              src={imgOne}
              alt="Анатомическое изображение малого таза женщины в виде капли"
              decoding="async"
              width={80}
              height={80}
            />
            <NumberOne className="number" aria-hidden="true" />
            <p className="hero_item_paragraph">
              гинекологический осмотр и УЗИ органов малого таза
            </p>
          </li>
          <li className="hero_middle_item">
            <img
              className="hero_middle_item_img"
              src={imgTwo}
              alt="Капля с микропузырьками"
              decoding="async"
              width={80}
              height={80}
            />
            <NumberTwo className="number" aria-hidden="true" />
            <p className="hero_item_paragraph">
              анализ предыдущих обследований и&nbsp;анализов
            </p>
          </li>
          <li className="hero_middle_item">
            <img
              className="hero_middle_item_img"
              src={imgThree}
              alt="Изображение лупы"
              decoding="async"
              width={80}
              height={80}
            />
            <NumberThree className="number" aria-hidden="true" />
            <p className="hero_item_paragraph">
              оценка возможных причин бесплодия и&nbsp;репродуктивных нарушений
            </p>
          </li>
          <li className="hero_middle_item">
            <img
              className="hero_middle_item_img"
              src={imgFour}
              alt="Потоки медицинского геля в движении"
              decoding="async"
              width={80}
              height={80}
            />
            <NumberFour className="number" aria-hidden="true" />
            <p className="hero_item_paragraph">
              готовый план лечения или подробная программа ЭКО
            </p>
          </li>
        </ul>
      </div>
      <div className="hero_title_wrapper">
        <h1 className="hero_title"><span>Бесплатный</span> приём репродуктолога</h1>
      </div>
      <div className="hero_end">
        <LazyOnView fallback="">
          <div className="hero_form_wrapper">
            <LazyAppointment />
          </div>
        </LazyOnView>
        <div className="hero_arrow_promo">
          <LayersIcon aria-label="Стрелка промо" />
        </div>
        {/* <p className="hero_text_promo">
          Пройди тест и получи скидку
        </p> */}
      </div>
    </section>
  );
};

export default Main;